import {
  Button,
  FormControl,
  Input,
  NumberInput,
  NumberInputField,
  Select,
  Td,
  Tr
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";

interface ILancamentoItem {
  item: LancamentoFinanceiro;
  showError: (title: string, msg: string) => void;
  editRowItem: (item: LancamentoFinanceiro) => void;
  deleteRowItem: (item: LancamentoFinanceiro) => void;
}

const LancamentoItem = ({
  showError,
  editRowItem,
  deleteRowItem,
  item,
}: ILancamentoItem) => {
  const [valor, setValor] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [acrescimo, setAcrescimo] = useState(0);
  const [obs, setObs] = useState("");
  const [tipoRecebimento, setTipoRecebimento] = useState("");

  const onChangeInput = (value: any, type: string) => {
    switch (type) {
      case "valor":
        setValor(value);
        break;
      case "desconto":
        setDesconto(value);
        break;
      case "acrescimo":
        setAcrescimo(value);
        break;
      case "obs":
        setObs(value);
        break;
      case "tipoRecebimento":
        setTipoRecebimento(value);
        break;
    }
  };

  useEffect(() => {
    if (item) {
      setAcrescimo(item.acrescimo);
      setDesconto(item.desconto);
      setValor(item.valor);
      setObs(item.obs);
      setTipoRecebimento(item.tipoRecebimento);
    }
  }, [item]);

  return (
    <Tr>
      <Td>
        <FormControl w={36}>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={
              item?.vencimento !== undefined
                ? new Date(item?.vencimento)
                : new Date()
            }
            onDateChange={(date: any) => {
              item.vencimento = date;
              editRowItem(item);
            }}
          />
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            precision={2}
            w={28}
            onChange={(e) => {
              onChangeInput(e, "valor");
            }}
            onBlur={(e) => {
              item.valor = Number(e.target.value);
              editRowItem(item);
            }}
            value={valor}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            w={28}
            precision={2}
            onChange={(e) => {
              onChangeInput(e, "acrescimo");
            }}
            onBlur={(e) => {
              item.acrescimo = Number(e.target.value);
              editRowItem(item);
            }}
            value={acrescimo}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <NumberInput
            min={0}
            precision={2}
            w={28}
            onChange={(e) => {
              onChangeInput(e, "desconto");
            }}
            onBlur={(e) => {
              item.desconto = Number(e.target.value);
              editRowItem(item);
            }}
            value={desconto}
          >
            <NumberInputField />
          </NumberInput>
        </FormControl>
      </Td>
      <Td>
        {formatNumber(
          Number(item.valor) + Number(item.acrescimo) - Number(item.desconto)
        )}
      </Td>
      <Td>
        <FormControl>
          <Select
            size="md"
            w={48}
            onChange={(e) => {
              onChangeInput(e.target.value, "tipoRecebimento");
              item.tipoRecebimento = e.target.value;
              editRowItem(item);
              }}
            value={tipoRecebimento}
          >
            <option value={"0"}>SELECIONE...</option>
            <option value={"1"}>BOLETO</option>
            <option value={"2"}>CHEQUE</option>
            <option value={"3"}>CARTÃO</option>
            <option value={"4"}>DINHEIRO</option>
            <option value={"5"}>DEPÓSITO</option>
            <option value={"6"}>DÉBITO EM CONTA</option>
            <option value={"7"}>FATURA</option>
            <option value={"8"}>ARRECADAÇÃO/RECEBIMENTO</option>
            <option value={"9"}>TRANSFÊRENCIA</option>
            <option value={"10"}>PIX</option>
          </Select>
        </FormControl>
      </Td>
      <Td>
        <FormControl>
          <Input
            defaultValue={obs}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha a Descrição"
            onChange={(e) => onChangeInput(e.target.value,  'obs')}
            onBlur={(e) => {
              item.obs = e.target.value;
              editRowItem(item);
            }}
            fontWeight="500"
            size="lg"
          />
        </FormControl>
      </Td>
      <Td>
        <Button
          onClick={() => {
            deleteRowItem(item);
          }}
          colorScheme="red"
          variant="ghost"
        >
          REMOVER
        </Button>
      </Td>
    </Tr>
  );
};

export default LancamentoItem;
